/**
 * Generated by orval v6.28.2 🍺
 * Do not edit manually.
 * Maybern
 * Maybern API
 * OpenAPI spec version: 0.0.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query'
import type {
  FundFamilyConfigEnrichedData
} from '../../model/fundFamilyConfigEnrichedData'
import type {
  FundFamilyConfigReadData
} from '../../model/fundFamilyConfigReadData'
import type {
  FundFamilyConfigUpsertDataRequest
} from '../../model/fundFamilyConfigUpsertDataRequest'
import { axiosRequest } from '../../../shared/api/Api';


      
type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];



      import { appQueryClient } from "app/AppQueryClient";
      import { LoaderFunction, Params } from "@remix-run/router";
      import { isLoggedIn } from "axios-jwt";

      const authedLoader = (loader: LoaderFunction): LoaderFunction =>
        async (args) => {
          const result = await isLoggedIn();
          if (result) {
            return loader(args);
          }
          return null;
        };
    /**
 * Gets a FundFamilyConfig
 */
export const fundFamilyConfigRetrieve = (
    fundFamilyId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<FundFamilyConfigEnrichedData>(
      {url: `/fund-family-config/${fundFamilyId}/`, method: 'GET', signal
    },
      options);
    }
  

export const getFundFamilyConfigRetrieveQueryKey = (fundFamilyId: string,) => {
    return [`/fund-family-config/${fundFamilyId}/`] as const;
    }

    
export const getFundFamilyConfigRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof fundFamilyConfigRetrieve>>, TError = unknown>(fundFamilyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fundFamilyConfigRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFundFamilyConfigRetrieveQueryKey(fundFamilyId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof fundFamilyConfigRetrieve>>> = ({ signal }) => fundFamilyConfigRetrieve(fundFamilyId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fundFamilyConfigRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FundFamilyConfigRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof fundFamilyConfigRetrieve>>>
export type FundFamilyConfigRetrieveQueryError = unknown

export const useFundFamilyConfigRetrieve = <TData = Awaited<ReturnType<typeof fundFamilyConfigRetrieve>>, TError = unknown>(
 fundFamilyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fundFamilyConfigRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFundFamilyConfigRetrieveQueryOptions(fundFamilyId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getFundFamilyConfigRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof fundFamilyConfigRetrieve>>, TError = unknown>(fundFamilyId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof fundFamilyConfigRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFundFamilyConfigRetrieveQueryKey(fundFamilyId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof fundFamilyConfigRetrieve>>> = ({ signal }) => fundFamilyConfigRetrieve(fundFamilyId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof fundFamilyConfigRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FundFamilyConfigRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof fundFamilyConfigRetrieve>>>
export type FundFamilyConfigRetrieveSuspenseQueryError = unknown

export const useFundFamilyConfigRetrieveSuspense = <TData = Awaited<ReturnType<typeof fundFamilyConfigRetrieve>>, TError = unknown>(
 fundFamilyId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof fundFamilyConfigRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFundFamilyConfigRetrieveSuspenseQueryOptions(fundFamilyId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getFundFamilyConfigRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId) {
            return appQueryClient.prefetchQuery({
              queryKey: getFundFamilyConfigRetrieveQueryKey(fundFamilyId),
              queryFn: () => fundFamilyConfigRetrieve(fundFamilyId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Update a FundFamilyConfig
 */
export const fundFamilyConfigCreate = (
    fundFamilyId: string,
    fundFamilyConfigUpsertDataRequest: FundFamilyConfigUpsertDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<FundFamilyConfigReadData>(
      {url: `/fund-family-config/${fundFamilyId}/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: fundFamilyConfigUpsertDataRequest
    },
      options);
    }
  


export const getFundFamilyConfigCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fundFamilyConfigCreate>>, TError,{fundFamilyId: string;data: FundFamilyConfigUpsertDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof fundFamilyConfigCreate>>, TError,{fundFamilyId: string;data: FundFamilyConfigUpsertDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof fundFamilyConfigCreate>>, {fundFamilyId: string;data: FundFamilyConfigUpsertDataRequest}> = (props) => {
          const {fundFamilyId,data} = props ?? {};

          return  fundFamilyConfigCreate(fundFamilyId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FundFamilyConfigCreateMutationResult = NonNullable<Awaited<ReturnType<typeof fundFamilyConfigCreate>>>
    export type FundFamilyConfigCreateMutationBody = FundFamilyConfigUpsertDataRequest
    export type FundFamilyConfigCreateMutationError = unknown

    export const useFundFamilyConfigCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fundFamilyConfigCreate>>, TError,{fundFamilyId: string;data: FundFamilyConfigUpsertDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getFundFamilyConfigCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Update a FundFamilyConfig
 */
export const fundFamilyConfigUpdate = (
    fundFamilyId: string,
    fundFamilyConfigUpsertDataRequest: FundFamilyConfigUpsertDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<FundFamilyConfigEnrichedData>(
      {url: `/fund-family-config/${fundFamilyId}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: fundFamilyConfigUpsertDataRequest
    },
      options);
    }
  


export const getFundFamilyConfigUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fundFamilyConfigUpdate>>, TError,{fundFamilyId: string;data: FundFamilyConfigUpsertDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof fundFamilyConfigUpdate>>, TError,{fundFamilyId: string;data: FundFamilyConfigUpsertDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof fundFamilyConfigUpdate>>, {fundFamilyId: string;data: FundFamilyConfigUpsertDataRequest}> = (props) => {
          const {fundFamilyId,data} = props ?? {};

          return  fundFamilyConfigUpdate(fundFamilyId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FundFamilyConfigUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof fundFamilyConfigUpdate>>>
    export type FundFamilyConfigUpdateMutationBody = FundFamilyConfigUpsertDataRequest
    export type FundFamilyConfigUpdateMutationError = unknown

    export const useFundFamilyConfigUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fundFamilyConfigUpdate>>, TError,{fundFamilyId: string;data: FundFamilyConfigUpsertDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getFundFamilyConfigUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    